//TODO: Check and Remove Duplicate components in this file and libs/insurance-landing-ui/src/lib/components (Present for Landing Page Components)
import { debounce, interpolateRowHeight, Region } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import { SpanTag } from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import {
  ListChildComponentProps,
  VariableSizeList as FixList,
} from "react-window";
import CheckButton from "../CheckButton/CheckButton";
import FlexComp from "../FlexComp/FlexComp";
import FormattedText from "../FormattedText/FormattedText";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import AnchorTag from "../TextStyles/AnchorTag";
import {
  ArrowButtonWrap,
  ColumnWrapper,
  DescriptionWrap,
} from "./CountryList.style";
import { CountryItem } from "./SelectCountryModalV2.style";
interface CountryListProps {
  countryData: any[];
  countryHandler: (code: string) => void;
  isCheckedHandler: (data: any) => boolean;
  searchQueryHighlighter: any;
  setCountryData: Dispatch<SetStateAction<any[]>>;
  setIsSelectedError: Dispatch<SetStateAction<boolean>>;
  showHeader: boolean;
  setCountrySelectToastMsg: Dispatch<SetStateAction<string>>;
  customHeight?: number;
}

const CountryList = ({
  countryData,
  countryHandler,
  isCheckedHandler,
  setCountryData,
  searchQueryHighlighter,
  setIsSelectedError,
  showHeader,
  setCountrySelectToastMsg,
  customHeight = 380,
}: CountryListProps) => {
  const device = useBreakpointV2();
  //TODO: handle default cell height using css var
  const defaultCellHeight = 57;
  //TODO: Check alternate height calculation using DOM elements
  const windowHeight = window.innerHeight - 213;
  const windowWidth = window.innerWidth - 60;
  const listRef = useRef<FixList>(null);
  const context = usePartnerContext();
  const [showViewAllButton, setShowViewAllButton] = useState<boolean>(false);
  useEffect(() => {
    const temp = countryData.map((data: any) => {
      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  }, []);
  useEffect(() => {
    listRef?.current?.resetAfterIndex(0);
  }, [countryData]);

  const handleDescription = (code: string) => {
    const data = countryData.filter((data: any) => data?.code === code)[0];
    if (data.showExpandedDescription || data.description.length < 80) {
      setShowViewAllButton(false);
      console.log(data.description.length);
      return data.description;
    }
    setShowViewAllButton(true);
    const tempDescData = data.description.substring(0, 80).split(" ");
    tempDescData.pop();
    const descData = tempDescData.join(" ") + "...";
    return descData;
  };

  const handleRegionDescription = (code: string) => {
    let temp = countryData.map((data: any) => {
      if (data.code === code && !data.showDescription) {
        data["showDescription"] = true;
        data["showExpandedDescription"] = false;
        return data;
      }
      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  };

  const handleErrorToast = debounce(() => {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  const handleCountrySelectError = (country: any) => {
    const isExclusiveCountrySelected = countryData.find(
      (item: any) => item.isExclusiveSelection && item.isSelected
    );

    if (
      isExclusiveCountrySelected &&
      !country?.isExclusiveSelection &&
      country.isDisabled
    ) {
      setCountrySelectToastMsg(
        "Selected country cannot be chosen for domestic coverage"
      );
      handleErrorToast();
    } else if (
      country?.isExclusiveSelection &&
      !isExclusiveCountrySelected &&
      country.isDisabled
    ) {
      setCountrySelectToastMsg(
        "India cannot be chosen for International Travel"
      );
      handleErrorToast();
    } else if (country.isDisabled) {
      setIsSelectedError(true);
      handleErrorToast();
    } else {
      {
        !country.isSelected &&
          !country.showDescription &&
          handleRegionDescription(country.code);
      }
      {
        country.isSelected &&
          country.showDescription &&
          handleRegionDescription(country.code);
      }
      countryHandler(country.code);
    }
  };

  const handleViewAll = (code: string) => {
    let temp = countryData.map((data: any) => {
      if (data.code === code) {
        data["showExpandedDescription"] = !data["showExpandedDescription"];
      }
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  };
  //TODO: optimise logic for isExclusiveCountrySelected
  const checkGreyOut = (item: any): boolean => {
    const isExclusiveCountrySelected = !!countryData.find(
      (item: any) => item.isExclusiveSelection && item.isSelected
    );

    if (
      isExclusiveCountrySelected &&
      !item?.isExclusiveSelection &&
      item.isDisabled
    ) {
      return true;
    }
    if (
      item?.isExclusiveSelection &&
      !isExclusiveCountrySelected &&
      item.isDisabled
    ) {
      return true;
    }
    return false;
  };

  const rowRenderer = ({ index, key }: { index: number; key: number }) => {
    const item = countryData?.[index];
    if (!item) {
      return null; // Return null if item is undefined
    } else if (item.type === "HEADER") {
      return (
        showHeader && (
          <CountryItem
            disableCursor={true}
            margin={device === "lg" ? "0px 17px 0px 0px" : ""}
          >
            <FormattedText
              value={item.name}
              baseStyle={{ fontWeight: "bold", fontSize: "14px" }}
            />
          </CountryItem>
        )
      );
    } else if (item.code) {
      return (
        <div key={key}>
          <CountryItem
            disableCursor={true}
            margin={device === "lg" ? "0px 17px 0px 0px" : ""}
          >
            <FlexComp>
              <CheckButton
                handleChange={() => handleCountrySelectError(item)}
                isChecked={item.isDisabled ? true : isCheckedHandler(item)}
                isDisabled={item.isDisabled}
                greyOut={checkGreyOut(item)}
              >
                <FlexComp
                  handleClick={() => handleCountrySelectError(item)}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {item.subtitle ? (
                    <ColumnWrapper>
                      <SpanTag>{searchQueryHighlighter(item.name)}</SpanTag>
                      <SpanTag>
                        <FormattedText
                          value={item.subtitle}
                          baseStyle={{
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        />
                      </SpanTag>
                    </ColumnWrapper>
                  ) : (
                    searchQueryHighlighter(item.name)
                  )}
                  <FormattedText
                    value={item.countryCount}
                    baseStyle={{
                      padding: "0px 10px 0px 0px",
                      fontSize: "12px",
                      color: "#4A4A4A",
                    }}
                  />
                  <FormattedText
                    value={item.regionName}
                    baseStyle={{
                      fontSize: "12px",
                      color: "#0000004D",
                    }}
                  />
                </FlexComp>
              </CheckButton>
              {item.type === "REGION" && (
                <ArrowButtonWrap
                  onClick={() => {
                    handleRegionDescription(item.code);
                  }}
                >
                  <ImageComponent
                    width="9px"
                    height="9px"
                    margin="0px 0px 0px 0px"
                    src={
                      item.showDescription
                        ? context === PARTNER.MYBIZ
                          ? "https://tripmoneycmsimgak.mmtcdn.com/img/Right_Arrow_b9b5e073fa.png"
                          : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg"
                        : context === PARTNER.MYBIZ
                        ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_f3475d8184.png"
                        : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg"
                    }
                  />
                </ArrowButtonWrap>
              )}
            </FlexComp>
            {item.showDescription && item.type === "REGION" && (
              <DescriptionWrap>
                <FormattedText
                  value={item.descTitle}
                  baseStyle={{
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                />
                <div>
                  <FormattedText
                    value={handleDescription(item.code)}
                    baseStyle={{
                      fontSize: "14px",
                    }}
                  />
                </div>
                {showViewAllButton && (
                  <AnchorTag
                    handleClick={() => {
                      handleViewAll(item.code);
                    }}
                    fontWeight="bold"
                    color="var(--tm-accent-color)"
                  >
                    View All
                  </AnchorTag>
                )}
              </DescriptionWrap>
            )}
          </CountryItem>
        </div>
      );
    }
    return;
  };

  const getItemSize = (
    code: Region,
    isShowDesc: boolean,
    isShowAllDesc: boolean
  ) => {
    let expansionValue = 0;
    if (isShowAllDesc) {
      expansionValue = 2;
    } else if (isShowDesc) {
      expansionValue = 1;
    }
    return (
      interpolateRowHeight(
        device === "lg" ? 360 : windowWidth,
        code,
        expansionValue
      ) || defaultCellHeight
    );
  };

  const getItemSizes = (index: any) => {
    const height =
      countryData[index].type === "REGION"
        ? getItemSize(
            countryData[index].code,
            countryData[index].showDescription,
            countryData[index].showExpandedDescription
          )
        : defaultCellHeight;
    return height;
  };

  return (
    <FixList
      height={device === "lg" ? customHeight : windowHeight}
      itemCount={countryData.length}
      itemSize={getItemSizes}
      width={device === "lg" ? '100%' : windowWidth}
      ref={listRef}
    >
      {({ index, style }: ListChildComponentProps) => {
        return (
          <div style={style} key={index}>
            {rowRenderer({ index, key: index })}
          </div>
        );
      }}
    </FixList>
  );
};

export default CountryList;
